import { useContext } from 'react';
import { AxiosClientContext } from '@providers';

export function useApi() {
  return useContext(AxiosClientContext);
}
